import { useWindowResize } from '@aperza/ui';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from './Carousel.module.scss';
const leftTransition = 'left 0.3s ease-in-out';
const leftNoTransition = 'left 0.3s ease-in-out';
const Carousel = (props) => {
    const { items = [] } = props;
    const carouselEl = useRef(null);
    const carouselSliderEl = useRef(null);
    const [carouselHeight, setCarouselHeight] = useState(0);
    const [itemWidth, setItemWidth] = useState(0);
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(items.length);
    const [transition, setTransition] = useState(leftNoTransition);
    const { t } = useTranslation();
    const updateWidth = () => {
        setTransition(leftNoTransition);
        const width = carouselEl.current ? carouselEl.current.clientWidth : 0;
        const height = carouselSliderEl.current ? carouselSliderEl.current.clientHeight : 0;
        if (width) {
            setItemWidth(width);
        }
        if (height)
            setCarouselHeight(height);
    };
    useWindowResize(updateWidth);
    const onClickPrev = () => {
        if (page > 0) {
            setTransition(leftTransition);
            const newPage = page - 1;
            setPage(newPage);
        }
    };
    const onClickNext = () => {
        if (page + 1 < pageCount) {
            setTransition(leftTransition);
            const newPage = page + 1;
            setPage(newPage);
        }
    };
    const hasPrev = () => {
        return pageCount > 0 && page > 0;
    };
    const hasNext = () => {
        return pageCount > 0 && page + 1 < pageCount;
    };
    useEffect(() => {
        updateWidth();
        setPageCount(items.length);
    }, [items]);
    const images = items.map((item, index) => {
        return (React.createElement("div", { key: index, style: { width: itemWidth } },
            React.createElement("div", { className: style.imageWrapper },
                React.createElement("img", { className: style.image, src: item.imageUrl, onLoad: updateWidth }))));
    });
    return (React.createElement("div", { ref: carouselEl, className: style.Carousel, style: { height: carouselHeight } },
        React.createElement("div", null,
            React.createElement("i", { className: clsx('fa', 'fa-angle-left', style.CarouselButtonLeft, {
                    [style.CarouselButtonDisabled]: !hasPrev(),
                }), "aria-hidden": "true", onClick: onClickPrev })),
        React.createElement("div", null,
            React.createElement("i", { className: clsx('fa', 'fa-angle-right', style.CarouselButtonRight, {
                    [style.CarouselButtonDisabled]: !hasNext(),
                }), "aria-hidden": "true", onClick: onClickNext })),
        React.createElement("div", { className: style.CarouselPage },
            page + 1,
            "/",
            pageCount),
        React.createElement("div", { ref: carouselSliderEl, className: style.CarouselSlider, style: {
                zIndex: -1,
                transition,
                width: itemWidth * pageCount,
                left: 0 - page * itemWidth,
            } }, images)));
};
Carousel.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        imageUrl: PropTypes.string,
    })),
};
export default Carousel;
